import { Stack } from "@mui/material";
import { matchPath, Outlet, useLocation } from "react-router-dom";
import { SegmentedNav } from "../../../common/components/SegmentedNav";

/**
 * Child source pages own their headings and data; this layout owns navigation
 * only: the Tournaments · Leagues · Mine · Rankings switch on the Compete
 * roots. Detail screens (a tournament, a league division) carry their own
 * one-row header instead, so the switch is not shown there.
 */
export function CompeteLayout() {
  const { pathname, search } = useLocation();
  const facilityId = new URLSearchParams(search).get("facility_id");
  const scoped = (path: string) =>
    facilityId ? `${path}?${new URLSearchParams({ facility_id: facilityId })}` : path;
  const detail =
    matchPath("/tournaments/:tournamentId", pathname) !== null ||
    matchPath("/compete/leagues/divisions/*", pathname) !== null;
  const active =
    pathname === "/compete/mine"
      ? "mine"
      : pathname === "/rankings"
        ? "rankings"
        : matchPath("/compete/leagues/*", pathname)
          ? "leagues"
          : "tournaments";
  return (
    <Stack spacing={2}>
      {detail ? null : (
        <SegmentedNav
          label="Competition views"
          active={active}
          items={[
            { id: "tournaments", label: "Tournaments", to: scoped("/compete/tournaments") },
            { id: "leagues", label: "Leagues", to: scoped("/compete/leagues") },
            { id: "mine", label: "Mine", to: "/compete/mine" },
            { id: "rankings", label: "Rankings", to: scoped("/rankings") },
          ]}
        />
      )}
      <Outlet />
    </Stack>
  );
}
